import React, { Component } from 'react';
import {RegWrapper} from './RegWrapper.js'
import axios from 'axios';
import {Loader} from './Loader.js';

export class RestorePass extends Component {

    state = {
        sentRequest : !true,
        email : ''
    }

    constructor(props) {
        super(props)
        this.props = props 
    }

    updateEmailValue = (e) => {
        const updatedInputValue = e.target.value;
        // ...
        
        this.setState((prevState) => {
             return  {
                    ...prevState,
                    email : updatedInputValue
                
                };
        }, () =>  {
            
        })
    
    }


    sendRequest = (e) => {
        
        e.preventDefault()
        this.setState((prevState) => {
            return  {
                   ...prevState,
                   
                   isSending : true
               
               };
        }, () =>  {
           
        })
        axios.post('https://api.clickanti.ru/api/users/request-password-reset/', 
        {
            email: this.state.email
        }
        )
        .then(res => {
            
            if( res.data.status == 'ok') {
                this.setState((prevState) => {
                    return  {
                           ...prevState,
                           sentRequest : true,
                           isSending : false
                       
                       };
                }, () =>  {
                   
                })
            }
            
 
        })
        
    }

    render() {
        return (
            
            <RegWrapper showErrorMsg={false}>
            <Loader loader={this.state.isSending} />
            
            <>{
                this.state.sentRequest === false ? 
                <div className='restorePasswordBlock'>
                    <div><h1>Забыли пароль?</h1></div>
                    <div class="uk-flex-column">
                        <div><p>Введите адрес электронной почты, который вы использовали при регистрации, и мы вышлем вам инструкции по сбросу пароля.</p></div>
                       </div>
                
                <div class="uk-margin">
                    <input class="uk-input uk-form-width-large uk-form-large uk-background-muted"
                    type="text" placeholder="E-mail*"
                    onChange={e => this.updateEmailValue(e) }
                    value={this.state.email} />
                </div>
                <div class="main-left-bottom">
                    
                    <button onClick={e => this.sendRequest(e)} class="btn1">Восстановить пароль</button>
                </div>
                </div>
                 : 
                 <div>
                     <h1 className='center'>Прислали на почту инструкции.
                    Письмо могло попасть в папку спам. 
                    Если письмо не пришло в течение 1 минуты, 
                     <a href={process.env.REACT_APP_SUPPORT_LINK}> напишите в тех. поддержку </a></h1>
                 </div>
            } </> 
            
               

            </RegWrapper>  

        )
    }

}